import { LogoFileMimeType } from 'libs/end-to-end/src/logos';
import { z } from 'zod';

/**
 * Nested object with the relationships between organizations, databases, and revisions.
 * @example {
 *  organizations: {
 *    org1: {
 *      id: "org1",
 *      name: "Org 1",
 *
 *      databases: {
 *        db1": {
 *          id: "db1",
 *          name: "DB 1",
 *
 *          revisions: {
 *            latest: {
 *              id:
 *              'rev1',
 *              name: 'Rev 1'
 *            },
 *            rev1: {
 *              id: "rev1",
 *             name: "Rev 1"
 *            }
 *          }
 *        }
 *      }
 *    }
 *  }
 */
export const MyOrganizationsDatabasesAndRevisions = z.object({
  organizations: z.record(
    z.string() /* organizationId */,
    z.object({
      id: z.string(),
      name: z.string(),
      logoMimeType: LogoFileMimeType.optional(),
      logoUrl: z.string().optional(),
      databases: z.record(
        z.string() /* databaseId */,
        z.object({
          id: z.string(),
          name: z.string(),
          revisions: z.intersection(
            z.object({
              latest: z.object({ id: z.string(), name: z.string() }),
            }),
            z.record(
              z.string() /* revisionId */,
              z.object({
                id: z.string(),
                name: z.string(),
              }),
            ),
          ),
        }),
      ),
    }),
  ),
});

export type MyOrganizationsDatabasesAndRevisions = z.infer<
  typeof MyOrganizationsDatabasesAndRevisions
>;
